/**
 * * src/utils/undoRedo/commands/BoxCommand.js
 * BoxCommand.js
 * Supply point (Box) ekleme/silme komutları
 */

import BaseCommand from './BaseCommand';
import { addComponent, removeComponent } from '../../../redux/simpleSupplySlice';
import * as THREE from 'three';
import { createSupplyPoint } from '../../../factory/symbols/createSupplyPoint';
// attachUsingDirectionToGroup KALDIRILDI - Box kaybolma fix

class BoxCommand extends BaseCommand {
  constructor(action, boxData, sceneData, options = {}) {
    super(action === 'ADD' ? 'ADD_BOX' : 'DELETE_BOX', {
      before: action === 'DELETE' ? boxData : null,
      after: action === 'ADD' ? boxData : null
    }, sceneData);

    this.action = action; // 'ADD' veya 'DELETE'
    this.scene = options.scene; // 🟢 Sahne referansı
    this.dispatch = options.dispatch; // 🟢 Redux dispatch
  }

  /**
   * Box ekleme/silme işlemini gerçekleştir
   */
  execute() {
    if (!this.scene || !this.dispatch) {
      return;
    }

    if (this.action === 'ADD') {
      this._addBox();
    } else if (this.action === 'DELETE') {
      this._deleteBox();
    }
  }

  /**
   * Box ekleme/silme işlemini geri al
   */
  undo() {
    if (!this.scene || !this.dispatch) {
      return;
    }

    if (this.action === 'ADD') {
      // ADD işlemini geri al = DELETE yap
      this._deleteBox();
    } else if (this.action === 'DELETE') {
      // DELETE işlemini geri al = ADD yap
      this._addBox();
    }
  }

  /**
   * Sahneye box ekle
   */
  _addBox() {
    const boxData = this.data.after || this.data.before;

    // Redux'a ekle
    this.dispatch(addComponent(boxData));

    // Three.js sahnesine ekle
    const mousePos = new THREE.Vector3(
      this.sceneData.position[0],
      this.sceneData.position[1],
      this.sceneData.position[2]
    );

    const symbol = createSupplyPoint(
      this.scene,
      mousePos,
      boxData.name || 'Supply',
      boxData.id
    );

    symbol.rotation.z = this.sceneData.rotation || 0;

    symbol.userData = {
      type: 'supplyPoint',  // ✅ DrawingCanvas'ta 'supplyPoint' aranıyor
      id: boxData.id,
      isElectrical: true,
      ...boxData
    };

    // Sahneye ekle (floorPlanGroup'a değil, direkt scene'e) - Box kaybolma fix
    this.scene.add(symbol);
  }

  /**
   * Sahneden box sil
   */
  _deleteBox() {
    const boxData = this.data.after || this.data.before;

   // Redux'tan sil
    this.dispatch(removeComponent(boxData.id));

    // Three.js sahnesinden sil - scene.children ve floorPlanGroup içinde ara
    let objectToRemove = null;

    this.scene.traverse(obj => {
      if (obj.userData?.type === 'supplyPoint' && obj.userData?.id === boxData.id) {
        objectToRemove = obj;
      }
    });

    if (objectToRemove) {
      // Geometry ve material temizliği
      objectToRemove.traverse(child => {
        if (child.geometry) child.geometry.dispose();
        if (child.material) {
          if (Array.isArray(child.material)) {
            child.material.forEach(mat => mat.dispose());
          } else {
            child.material.dispose();
          }
        }
      });

      // Parent'tan sil (floorPlanGroup veya scene olabilir)
      if (objectToRemove.parent) {
        objectToRemove.parent.remove(objectToRemove);
      } else {
        this.scene.remove(objectToRemove);
      }
    } else {
      console.warn('⚠️ Silinecek box bulunamadı!');
    }
  }

  /**
   * JSON'dan BoxCommand oluştur
   */
  static fromJSON(json) {
    const action = json.type === 'ADD_BOX' ? 'ADD' : 'DELETE';
    const boxData = json.data.after || json.data.before;
    return new BoxCommand(action, boxData, json.sceneData);
  }
}

export default BoxCommand;
